import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAspectRatio219 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.4 8.2H17.6A2.8 2.8 0 0 1 20.4 11V13A2.8 2.8 0 0 1 17.6 15.8H6.4A2.8 2.8 0 0 1 3.6 13V11A2.8 2.8 0 0 1 6.4 8.2ZM6.4 9.8A1.2 1.2 0 0 0 5.2 11V13A1.2 1.2 0 0 0 6.4 14.2H17.6A1.2 1.2 0 0 0 18.8 13V11A1.2 1.2 0 0 0 17.6 9.8H6.4Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgAspectRatio219);
export default ForwardRef;
